<template>
  <section>
    <h2 class="h2Title">{{ product.productName }} 상세 조회</h2>
    <div class="formInfo">
      <dl class="infoCont">
        <v-row>
          <v-col sm="4">
            <div class="d-flex" style="padding-left: 50px">

              <div class="swiper-button-prev">
                <i class="iconfont icon-arrow-down"></i>
              </div>
              <div class="swiper-button-next">
                <i class="iconfont icon-arrow-up"></i>
              </div>

              <div v-if="product.productImages && product.productImages.length > 0" class="mr-2" style="background-color: #ffffff; min-height: 460px">

                <swiper
                    class="swiper"
                    :options="swiperOption"
                >
                  <swiper-slide v-for="(image, i) in product.productImages"
                                :key="i"
                  >
                    <v-card height="80" @click="selectedImage = image">
                      <v-img
                          v-if="rendered"
                          height="80"
                          width="80"
                          class="rounded mb-2"
                          :src="`/attachment/product/${image.fileServerName}`"
                      />
                    </v-card>
                  </swiper-slide>
                </swiper>
              </div>

              <div class="d-flex align-center flex-grow-1 justify-center" v-if="selectedImage && selectedImage.fileServerName"  v-viewer style="min-height: 460px">
                <img
                    v-if="product.productImages"
                    :src="`/attachment/product/${selectedImage.fileServerName}`"
                    class="rounded"
                    style="max-width: 100%; max-height: 460px"
                />
              </div>

            </div>
          </v-col>
          <v-col sm="8">
            <div class="formInfo">
              <dl class="infoCont">
                <dt class="formInfoTxt">제품명 </dt>
                <dd class="formInfoArea">
                  {{ product.productName }}
                </dd>
              </dl>
              <dl class="infoCont">
                <dt class="formInfoTxt">소비자가격 </dt>
                <dd class="formInfoArea">
                  {{ product.price | numeralFormat('0,000') }}
                </dd>
              </dl>
            </div>
          </v-col>
        </v-row>
      </dl>

      <dl class="infoCont">
        <dd>
          <div v-html="product.productDetail ? product.productDetail.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''">
          </div>
        </dd>
      </dl>

<!--      <dl>-->
<!--        <div class="btnStyleBx">-->
<!--          <div class="btnCommon justify-center">-->

<!--            <v-btn @click="$router.push(`/product`)">취소</v-btn>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-btn color="orange" dark @click="deleteProduct" style="margin-right: 2px">삭제</v-btn>-->
<!--            <v-btn color="primary" @click="$router.push(`/product/form/${id}`)">수정</v-btn>-->
<!--          </div>-->
<!--        </div>-->
<!--      </dl>-->

    </div>

    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn class="vBtn" color="#fafafa" @click="$router.push(`/product`)"  style="margin-right: 2px">
          <v-icon left>mdi mdi-format-list-bulleted</v-icon>
          목록
        </v-btn>
        <v-btn class="vBtn" color="orange" dark @click="deleteProduct" style="margin-right: 2px">
          <v-icon left>mdi-delete</v-icon>
          삭제
        </v-btn>

        <v-btn class="vBtn" color="primary" dark @click="$router.push(`/product/form/${id}`)">
          <v-icon left>mdi mdi-content-save</v-icon>
          수정
        </v-btn>
      </div>
    </div>

  </section>
</template>

<script>
import ProductApi from "@/api/ProductApi";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
// import "swiper/swiper-bundle.css";
import "swiper/css/swiper.css";

export default {
  name: 'productDetail',
  props: ['id'],
  components:{
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      isLoading: false,
      breadcrumbs: [{
        text: '제품관리',
        disabled: false,
        to: '/product/list'
      }, {
        text: '제품상세',
        disabled: true,
        href: '#'
      }],

      product: {},
      selectedImage: {},
      rendered: false,
      swiperOption: {
        direction: 'vertical',
        // slidesPerView: 5,
        slidesPerView: 'auto',
        spaceBetween: 0,
        paginationClickable: true,
        loop: false,
        cycle: false,
        autoPlay: 1000,
        autoHeight: true,
        autoplayDisableOnInteraction: false,
        mouseWheelControl:true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // }
      }
    }
  },
  computed: {

  },
  methods: {
    getProduct() {
      ProductApi.get(this.id).then(data => {
        // console.log(data);
        this.product = data;
        this.selectedImage = this.product?.productImages?.[0]??{}
        setTimeout(() => {
          this.rendered = true;
        }, 300)
      })
    },
    deleteProduct() {
      if(confirm('삭제하시겠습니까?')) {
        ProductApi.delete(this.id).then(() => {
          alert("삭제되었습니다.")
          this.$router.push('/product')
        })
      }
    }
  },
  mounted() {

    if (typeof this.id !== 'undefined') {
      this.getProduct()
    } else {
      this.product = {}
    }

  }
}
</script>
<style lang="scss" scoped>

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-button-next,
.swiper-button-prev {
  //left: 50%;
  transform: rotate(90deg);
  transform-origin: left center;
  --swiper-navigation-size: 20px;

}

.swiper-button-prev {
  top: 35%;
  left: 252px;
  //left: 15%;
  //left: 0;
  //bottom: 90%
}

.swiper-button-next {
  top: 38%;
  //bottom: 10px;
  left: 252px;
  //left: 0;
  //bottom: 10%
}

//.swiper-container-vertical {
//}

//.swiper-pagination {
//  bottom: 50%;
//  left: 95%;
//  //transform: translateX(-50%);
//  .swiper-pagination-bullet {
//    background-color: rgba(255,255,255,0.5);
//    margin-right: 8px;
//    &.swiper-pagination-bullet-active {
//      background-color: #ffffff;
//    }
//  }
//}
</style>
